import { FC } from 'react';
import { GridFilterItem } from '../common/grid/GridFilterItem';
import {
  certificateListActions,
  CertificateListFilter,
} from '../../store/entities/certificateList';
import { GridFilterState } from '../common/grid/GridFilterState';

interface Props {
  query: CertificateListFilter;
}

export const DocumentFilter: FC<Props> = ({ query }) => {
  return (
    <>
      <GridFilterItem
        query={query}
        gridActions={certificateListActions}
        name="state"
        title="document.state"
        Component={GridFilterState}
      />
    </>
  );
};
